<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Daily operations Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="GetDailyOperationsQueryData('N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        v-if="dailyOperationsData.length > 0"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="GetDailyOperationsQueryData('Y')"
          title="Download as PDF"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="dailyOperationsData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left">Film</th>
                <th>Admits</th>
                <th>Sessons</th>
                <th colspan="2">Gross ATP</th>
                <th>Avg Perf Revenue</th>
                <th>Net BO Revenue</th>
                <th>Gross BO Revenue</th>
                <th>Advance Sales</th>
                <th>Prior Sales</th>
                <th>Redemptions</th>
                <th>Gross Receipts</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th>Incl Comps</th>
                <th>Excl Comps</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <template>
              <template v-for="(operationsData, index) in dailyOperationsData">
                <tr :key="index"  >
                  <td class="text-left">
                    {{ operationsData.movie_name }}
                  </td>
                  <td class="text-right">
                    {{ operationsData.admits }}
                  </td>
                  <td class="text-right">
                    {{ operationsData.sessions }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        operationsData.gross_bo_revenue / operationsData.admits
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        operationsData.gross_bo_revenue_no_comps /
                          operationsData.admits
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        operationsData.gross_bo_revenue /
                          operationsData.sessions
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(operationsData.net_bo_revenue) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(operationsData.gross_bo_revenue) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(operationsData.advance_sales) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(operationsData.prior_sales) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(operationsData.redemption_sales) }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        operationsData.gross_bo_revenue +
                          operationsData.advance_sales -
                          operationsData.prior_sales -
                          operationsData.redemption_sales
                      )
                    }}
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="1" class="text-left font-weight-bold">Total For Films</td>
                <td class="text-right font-weight-bold">
                  {{ grandTotal.admits }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ grandTotal.sessions }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.inc_comp) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.excl_comp) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.avg_pref_rev) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.net_bo_rev) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.gross_bo_rev) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.advanced_sales) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.prior_sales) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.redemptions) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ currFormat(grandTotal.gross_receipts) }}
                </td>
              </tr>
            </template>

            <template>
      <thead class="bg-lightgrey">
    <tr style="border: transparent">
      <th style="border: transparent" class="text-left">
        Box Office Sundry
      </th>
      <th></th>
      <th></th>
      <th colspan="2"></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th class="text-right">Total Net</th>
      <th class="text-right">Total Gross</th>
    </tr>
  </thead>
      <tr style="border: transparent">
        <td class="text-left">Other Fees</td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right">654</td>
        <td class="text-right">456</td>
      </tr>

      <tr style="border: transparent">
        <td class="text-left">Comps</td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right">45</td>
        <td class="text-right">45</td>
      </tr>
   
    <tr style="border: transparent">
      <td colspan="1" class="text-left font-weight-bold">Total Box Office Sundry Revenue</td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold">456</td>
      <td class="text-right font-weight-bold">654</td>
    </tr>
            </template>
            
            <template>
      <thead class="bg-lightgrey">
    <tr style="border: transparent">
      <th style="border: transparent" class="text-left">
        Other Sales
      </th>
      <th></th>
      <th></th>
      <th colspan="2"></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th class="text-right">Total Net</th>
      <th class="text-right">Total Gross</th>
    </tr>
  </thead>
      <tr style="border: transparent">
        <td class="text-left">Total Concession Sales</td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right">{{ currFormat(fnbTotalObj.ft_net_amount) }}</td>
        <td class="text-right">{{ currFormat(fnbTotalObj.ft_total_amount) }}</td>
      </tr>

    <tr style="border: transparent">
      <td colspan="1" class="text-left font-weight-bold"> Other Sales</td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold"></td>
      <td class="text-right font-weight-bold">{{ currFormat(fnbTotalObj.ft_net_amount) }}</td>
      <td class="text-right font-weight-bold">{{ currFormat(fnbTotalObj.ft_total_amount) }}</td>
    </tr>
            </template>

            <template >
      <tr style="border: transparent;">
        <td  class="text-left font-weight-bold">Total Daily Receipts from Operations</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">654</td>
        <td class="text-right">456</td>
      </tr>
            </template>
          </table>
        </div>
      </div>

      <div class="table-scroll" style="margin-top: 50px;">
         
            <template>
              <table class="swc-report-table swc_table_header"
            border="1" 
            v-if="dailyOperationsData.length > 0">
              <thead class="bg-lightgrey">
        <tr>
          <th class="text-left">Sources Of Revenue</th>
          <th v-for="(mode, modeIndex) in paymentModes" :key="modeIndex" class="text-right">{{ mode }}</th>
          <th class="text-right">Total Gross</th>
        </tr>
      </thead>
      <tr v-for="(revenueData, index) in final_source_of_revenue_data" :key="index">
          <td class="text-left">{{ revenueData.booking_source }}</td>
          <td v-for="(mode, modeIndex) in paymentModes" :key="modeIndex" class="text-right">
            {{ getPaymentAmount(revenueData, mode) }}
          </td>
          <td class="text-right">{{ calculateTotalGross(revenueData.data) }}</td>
        </tr>
        <tr>
          <td  class="text-left font-weight-bold">Totals</td>
          <template v-for="(mode, modeIndex) in paymentModes" >
            <td :key="modeIndex" class="text-right font-weight-bold">{{ calculateColumnTotal(modeIndex) }}</td>
          </template>
          <td class="text-right font-weight-bold">{{ calculateTotalGrossAll() }}</td>
        </tr>
      </table>
           </template>
           <table 
class="swc-report-table swc_table_header"
            border="1"
            v-if="dailyOperationsData.length > 0"
>
  <template>
    <thead class="bg-lightgrey">
  <tr style="border: transparent; height: 20px;">
    <th style="border: transparent" class="text-left">
      Cashier Over/Short
    </th>
    <th></th>
    <th class="text-right">Cash</th>
    <th></th>
    <th class="text-right">Other</th>
    <th class="text-right">Total Gross</th>
  </tr>
</thead>
    <tr style="border: transparent">
      <td class="text-left">Total Concession Sales</td>
      <th></th>
      <td class="text-right ">45</td>
      <th></th>
      <td class="text-right">67</td>
      <td class="text-right">456</td>
    </tr>

  <tr style="border: transparent">
    <td colspan="1" class="text-left font-weight-bold">Totals</td>
    <th></th>
    <td class="text-right font-weight-bold">45</td>
    <th></th>
    <td class="text-right font-weight-bold">67</td>
    <td class="text-right font-weight-bold">654</td>
  </tr>
  </template>

          <template>
    <thead class="bg-lightgrey">
  <tr style="border: transparent; height: 20px;">
    <th style="border: transparent" class="text-left">
      Expected Banking 
    </th>
    <th></th>
    <th class="text-right">Cash</th>
    <th></th>
    <th class="text-right">Other</th>
    <th class="text-right">Total Gross</th>
  </tr>
</thead>
    <tr style="border: transparent">
      <td class="text-left"></td>
      <th></th>
      <td class="text-right "></td>
      <th></th>
      <td class="text-right"></td>
      <td class="text-right"></td>
    </tr>

  <tr style="border: transparent">
    <td colspan="1" class="text-left font-weight-bold">Banking</td>
    <th></th>
    <td v-if="paymentModes.length > 0" class="text-right font-weight-bold">{{ calculateCashTotal() }}</td>     
    <th></th>
    <td class="text-right font-weight-bold">67</td>
    <td class="text-right font-weight-bold">654</td>
  </tr>
          </template>
        </table>
          
        </div>

        <div style="display: grid; grid-template-columns: 40% 60%;; margin-top: 10px; ">
          <div >
            <table 
            class="swc-report-table swc_table_header"
            border="1"
            v-if="dailyOperationsData.length > 0"
            style="height: 500px;"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left">Base Information</th>
                <th class="text-left">Today</th>
                <th class="text-left">Same Day Last Week</th>
              </tr>
            </thead>
              <template >
                <tr >
                  <td class="text-left">
                    Box Office Admits Incl Comps
                  </td>
                  <td>{{mergedObject.box_office_admits_incl_comps}}</td>
                  <td>{{mergedObject.last_week_box_office_admits_incl_comps}}</td>
                </tr>
                <tr >
                  <td class="text-left">
                   Comps
                  </td>
                  <td>{{mergedObject.comps}}</td>
                  <td>{{mergedObject.last_week_comps}}</td>
                </tr>
                <tr >
                  <td class="text-left">
                   Transactions with Tickets
                  </td>
                  <td>{{mergedObject.transactions_with_tickets}}</td>
                  <td>{{mergedObject.last_week_transactions_with_tickets}}</td>
                </tr>
                <tr >
                  <td class="text-left">
                   Transactions with Concessions
                  </td>
                  <td>{{mergedObject.trans_with_concessions}}</td>
                  <td>{{mergedObject.last_week_trans_with_concessions}}</td>
                </tr>
                <tr >
                  <td class="text-left">
                   Number Of Operators
                  </td>
                  <td>{{mergedObject.num_of_operators}}</td>
                  <td>{{mergedObject.num_of_operators_last_week}}</td>
                </tr>

            </template>
          </table>
          </div>

          <div>
        <table
        class="swc-report-table swc_table_header"
        border="1"
        v-if="dailyOperationsData.length > 0"
        
      >
      <tbody>
        <thead class="bg-lightgrey">
          <tr>
            <th class="text-left">Key Statistics</th>
            <th>Today</th>
            <th>Same Day Last Week</th>
            <th class="text-left">% Increase / Decreas</th>
            <th>Operator Hours</th>
            <th>Per Operator Hour</th>
          </tr>
        </thead>
          <tbody >
            <tr  >
              <td  class="text-left">
               total attendance
              </td>
              <td>{{mergedObject.box_office_admits_incl_comps}}</td>
              <td>{{mergedObject.last_week_box_office_admits_incl_comps}}</td>
              <td>{{currFormat((mergedObject.box_office_admits_incl_comps - mergedObject.last_week_box_office_admits_incl_comps) / mergedObject.last_week_box_office_admits_incl_comps * 100)}}%</td>
              <td>ert</td>
              <td></td>
            </tr>
          </tbody>

          <tbody >
            <tr  >
              <td colspan="6" class="text-left">
               Box Office Revenue
              </td>
            </tr>

            <tr  >
                <td  class="text-left">
                 Gross
                </td>
                <td> {{ currFormat(grandTotal.gross_bo_rev) }}</td>
                <td>{{ currFormat(grandTotalLastWeek.gross_bo_rev) }}</td>
                <td>{{currFormat((grandTotal.gross_bo_rev - grandTotalLastWeek.gross_bo_rev) / grandTotalLastWeek.gross_bo_rev * 100)}}%</td>
                <td></td>
                <td></td>
              </tr>

              <tr  >
                <td  class="text-left">
                    Net
                   </td>
                   <td> {{ currFormat(grandTotal.net_bo_rev) }}</td>
                   <td>{{ currFormat(grandTotalLastWeek.net_bo_rev) }}</td>
                   <td>{{currFormat((grandTotal.net_bo_rev - grandTotalLastWeek.net_bo_rev) / grandTotalLastWeek.net_bo_rev * 100)}}%</td>  
                   <td></td>
                   <td></td>
              </tr>
          </tbody>

          <tbody >
            <tr  >
              <td colspan="6" class="text-left">
                Concessions Revenue
              </td>
            </tr>
            <tr  >
                <td  class="text-left">
                 Gross
                </td>
                <td>{{ currFormat(fnbTotalObj.ft_total_amount) }}</td>
                <td>{{ currFormat(fnbTotalObj.last_week_ft_total_amount) }}</td>
                <td>{{currFormat((fnbTotalObj.ft_total_amount - fnbTotalObj.last_week_ft_total_amount) / fnbTotalObj.last_week_ft_total_amount * 100)}}%</td>
                <td></td>
                <td></td>
              </tr>
              <tr  >
                <td  class="text-left">
                    Net
                   </td>
                   <td>{{ currFormat(fnbTotalObj.ft_net_amount) }}</td>
                   <td>{{ currFormat(fnbTotalObj.last_week_ft_net_amount) }}</td>
                   <td>{{currFormat((fnbTotalObj.ft_net_amount - fnbTotalObj.last_week_ft_net_amount) / fnbTotalObj.last_week_ft_net_amount * 100)}}%</td> 
                   <td></td>
                   <td></td>
              </tr>
          </tbody>

          <tbody >
            <tr  >
              <td colspan="6" class="text-left">
                Spend Per Head
              </td>
            </tr>
            <tr  >
                <td  class="text-left">
                 Gross
                </td>
                <td>{{ currFormat( fnbTotalObj.ft_total_amount / mergedObject.box_office_admits_incl_comps ) }}</td>
                <td>{{ currFormat( fnbTotalObj.last_week_ft_total_amount / mergedObject.last_week_box_office_admits_incl_comps ) }}</td>
                <td>{{currFormat( (( fnbTotalObj.ft_total_amount / mergedObject.box_office_admits_incl_comps ) - ( fnbTotalObj.last_week_ft_total_amount / mergedObject.last_week_box_office_admits_incl_comps )) / ( fnbTotalObj.last_week_ft_total_amount / mergedObject.last_week_box_office_admits_incl_comps ) * 100)}}%</td>
                <td></td>
                <td></td>
              </tr>
              <tr  >
                <td  class="text-left">
                    Net
                   </td>
                   <td>{{ currFormat( fnbTotalObj.ft_net_amount / mergedObject.box_office_admits_incl_comps ) }}</td>
                   <td>{{ currFormat(fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_box_office_admits_incl_comps) }}</td>
                   <td>{{currFormat((fnbTotalObj.ft_net_amount / mergedObject.box_office_admits_incl_comps - fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_box_office_admits_incl_comps) / (fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_box_office_admits_incl_comps) *100)}}%</td> 
                   <td></td>
                   <td></td>
              </tr>
          </tbody>

          <tbody >
            <tr  >
              <td colspan="6" class="text-left">
                Average Concession Transaction Value
              </td>
            </tr>
            <tr  >
                <td  class="text-left">
                 Gross
                </td>
                <td>{{ currFormat(fnbTotalObj.ft_total_amount / mergedObject.trans_with_concessions) }}</td>
                <td>{{ currFormat(fnbTotalObj.last_week_ft_total_amount /mergedObject.last_week_trans_with_concessions) }}</td>
                <td>{{currFormat((fnbTotalObj.ft_total_amount / mergedObject.trans_with_concessions - fnbTotalObj.last_week_ft_total_amount / mergedObject.last_week_trans_with_concessions) / (fnbTotalObj.last_week_ft_total_amount / mergedObject.last_week_trans_with_concessions) * 100)}}%</td>
                <td></td>
                <td></td>
              </tr>
              <tr  >
                <td  class="text-left">
                    Net
                   </td>
                   <td>{{ currFormat(fnbTotalObj.ft_net_amount / mergedObject.trans_with_concessions) }}</td>
                   <td>{{ currFormat(fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_trans_with_concessions) }}</td>
                   <td>{{currFormat((fnbTotalObj.ft_net_amount / mergedObject.trans_with_concessions - fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_trans_with_concessions) / (fnbTotalObj.last_week_ft_net_amount / mergedObject.last_week_trans_with_concessions) * 100)}}%</td> 
                   <td></td>
                   <td></td>
              </tr>
          </tbody>
          </tbody>

      </table>
      </div>
        </div>

      
    <div class="table-scroll">
      <table
        v-if="dailyOperationsData.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <tr>
            <th rowspan="2" class="text-left">Films</th>
            <th rowspan="2">Admits</th>
            <th rowspan="2">Sessions</th>
            <th colspan="2">Gross ATP</th>
            <th rowspan="2">Avg Perf Revenue</th>
            <th rowspan="2">Net BO Revenue</th>
            <th rowspan="2">Gross BO Revenue</th>
            <th rowspan="2">Advance Sales</th>
            <th rowspan="2">Prior Sales</th>
            <th rowspan="2">Redemptions</th>
            <th rowspan="2">Gross Receipts</th>
          </tr>
          <tr>
            <th>Incl Comps</th>
            <th>Excl Comps</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="12">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      dailyOperations: {},
      grandTotal: {},
      paymentModes :[],
      final_source_of_revenue_data:[],
      dailyOperationsData:[],
      mergedObject : {},
      grandTotalLastWeek:{},
      fnbTotalObj:{}
        };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
 
    getPaymentAmount(revenueData, paymentModes) {
  const payment = revenueData.data.find(item => item.fst_payment_mode === paymentModes);
  return payment ? parseFloat(payment.fp_total_amount).toFixed(this.MIN_FRACTION_DIGITS) : 0;
},
    calculateTotalGross(data) {
      return data.reduce((acc, { fp_total_amount }) => acc + fp_total_amount, 0).toFixed(this.MIN_FRACTION_DIGITS);
    },
    calculateColumnTotal(modeIndex) {
      return this.final_source_of_revenue_data.reduce((acc, revenueData) => {
        const payment = revenueData.data.find(item => item.fst_payment_mode === this.paymentModes[modeIndex]);
        return acc + (payment ? parseFloat(payment.fp_total_amount) : 0);
      }, 0);
    },
    calculateTotalGrossAll() {
  return this.final_source_of_revenue_data.reduce((acc, revenueData) => {
    return acc + parseFloat(this.calculateTotalGross(revenueData.data));
  }, 0);
},

calculateCashTotal() {
    const cashMode = "Cash"; 
    const modeIndex = this.paymentModes.findIndex(mode => mode === cashMode);
    if (modeIndex === -1) {
      return 0; 
    }
    return this.final_source_of_revenue_data.reduce((acc, revenueData) => {
      const payment = revenueData.data.find(item => item.fst_payment_mode === cashMode);
      return acc + (payment ? parseFloat(payment.fp_total_amount) : 0);
    }, 0);
  },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetDailyOperationsQueryData(isPdf = "N") {
      this.dailyOperations = {};
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsService.GetDailyOperationsQueryData(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && Object.keys(data.Records).length) {
            this.dailyOperations = data.Records;
            console.log(this.dailyOperations)
            this.grandTotal = this.dailyOperations.grandTotal;
           
            this.dailyOperationsData = this.dailyOperations.dailyOperationsQueryData
            
            this.paymentModes = this.dailyOperations.paymentModes
           
            this.final_source_of_revenue_data = this.dailyOperations.final_source_of_revenue_data
           
            this.mergedObject = this.dailyOperations.mergedObject

            this.grandTotalLastWeek = this.dailyOperations.grandTotalLastWeek

            this.fnbTotalObj = this.dailyOperations.fnbTotalObj
           
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>


<style>
/* tr{
    border: transparent;
} */
.total_value_1 {
  border-top: solid black 1px;
}

.data {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailyOperationsReport.vue